@use 'src/styles/variables-bundle' as *;
@use 'src/templates/components/global/accessibility';

.ents-wishlist-button {
  position: relative;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  background: transparent;
  border: none;
  appearance: none;

  &:focus-within {
    @include outline;
  }
}

.ents-wishlist-button.styled {
  cursor: pointer;
  width: inherit;
  height: inherit;
  min-width: var(--ents-wishlist-button-min-size, spacer(10));
  min-height: var(--ents-wishlist-button-min-size, spacer(10));
  color: color('coal-100');
  display: inline-flex;
  align-items: center;
  justify-content: center;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: color('breuninger-red');
    }

    &.no-color:hover {
      color: color('ash');
    }

    &.selected {
      &:hover:not(.pulse) {
        color: color('coal-100');
      }

      &.no-color {
        &:hover {
          color: color('ash');
        }
      }
    }

    &.text {
      &:hover {
        .label {
          color: color('breuninger-red');
        }
      }
    }
  }

  &.no-description:focus-within {
    outline-offset: -1px;
  }

  &.selected {
    color: color('breuninger-red');

    &.pulse svg {
      animation: pulse 0.7s ease-in-out;

      @include prefersReducedMotion {
        animation: none;
      }
    }

    &.no-color {
      color: color('coal-100');
    }
  }

  &.text {
    width: auto;
    display: inline-flex;
    align-items: center;

    /* stylelint-disable-next-line no-descending-specificity */
    svg {
      margin-right: 3px;
    }

    .label {
      @include text-m;

      color: color('coal-100');
      margin-top: -1px;
    }
  }
}
